export const Scrapyard = {};
